import { ReactComponent as IconDarkFodler } from "@/assets/svgs/dark-folder.svg";
import { ReactComponent as Delete } from "@/assets/svgs/delete.svg";
import { ReactComponent as Eye } from "@/assets/svgs/eye.svg";
import { ReactComponent as IconClose } from "@/assets/svgs/icon-close.svg";
import Button from "@/components/Button/index";
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import { ToastContext } from "@/context/toast/index";
import api from "@/services/api/files";
import rem from "@/utils/rem";
import { useContext } from "react";
import { generateFileURLFromBase64 } from "@/utils/download";
import PropTypes from 'prop-types';

export default function AttachmentsViewModal({
	visible,
	close,
	data,
	dataElementId,
	type,
	handleRemoveAttachment,
	isEditable,
	hasExpired,
}) {
	const { addToastMessage } = useContext(ToastContext);

	const handlePreviewAttachment = async ({ file_content }) => {
		try {
			const res = await api.findOne(file_content);

			/* Generate fileURL from the base64 value */
			const fileURL = generateFileURLFromBase64(
				res.data.data,
				'application/pdf;base64',
			);

			/* Opening the generated file URL */
			window.open(fileURL);
		} catch(err) {
			console.error({err, message: "Unable to preview attachment!"});
			addToastMessage(
				err?.response?.data?.error?.message ||
					"File Preview Failed",
				"error"
			);
		};
	};
	return (
		<Modal visible={visible} variant="medium" close ={close} >
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon'}>
										<IconDarkFodler />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Attachments ({data?.length || 0})
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						{data?.map(
							(attachment, index) =>
								attachment.filename && (
									<div
										className="eclip-data-elements__attachment eclip-data-elements_list-item tooltip"
										key={`att-${index}`}
									>
										<span className="filename">
											{attachment.filename}
										</span>
										<span className="tooltiptext">
											{attachment.filename}
										</span>
									<span className="eclip-data-elements__structured-data__attachment__action">
										{!hasExpired && <span
											role="none"
											className="eclip-data-elements__attachment_link"
											onClick={() => {
												handlePreviewAttachment(attachment);
											}}
											onKeyDown={() => {
												handlePreviewAttachment(attachment);
											}}
											data-testid={"download-button"}
										>
											<Eye fill="#A614B9" />
										</span>}
										{isEditable && (
											<span className="eclip-data-elements__attachment_link">
												<Delete
													onClick={() => {
														handleRemoveAttachment(
															dataElementId,
															type,
															index
														);
													}}
												/>
											</span>
										)}
										</span>
									</div>
								)
						)}
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button ghost text="Close" submit={close} />
						<span
							style={{ width: rem(10), display: "inline-block" }}
						></span>
						{/* <Button
							text="Confirm"
							loading={loading}
							disabled={loading || name === '' || error !== ''}
							submit={handleCreateFolderSubmit}
						/> */}
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	);
};

AttachmentsViewModal.propTypes = {
	visible: PropTypes.bool,
	close: PropTypes.func,
	data: PropTypes.array,
	dataElementId: PropTypes.any,
	type: PropTypes.any,
	handleRemoveAttachment: PropTypes.func,
	isEditable: PropTypes.bool,
	hasExpired: PropTypes.bool,
};
